module.exports = __webpack_public_path__ + "static/media/icon-home-active.add90c0f.svg";